import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { Observable } from 'rxjs';
import { AuthService } from '@core/service/auth.service';


@Injectable()
export class ConnectionService extends RequestService {

  constructor(public override http: HttpClient, public _authService: AuthService) {
    super(http);
  }

  // WEB URL
  public getWebBase = this.webBase;

  public apiPostCall(url: any, obj: any): Observable<any> {
    var headerDict
    headerDict = {
      'Authorization': `Bearer ${localStorage.getItem('userSecret')}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    const completeUrl = this.apiUrl(url);
    return this.http.post(completeUrl, obj, requestOptions)
  }

  public apiGetCall(url: any): Observable<any> {
    var headerDict
    headerDict = {
      'Authorization': `Bearer ${localStorage.getItem('userSecret')}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache'
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    const completeUrl = this.apiUrl(url);
    return this.http.get(completeUrl, requestOptions)
  }


  public apiCallPublic(url: any, obj: any, SchoolID: any, Year: any): Observable<any> {
    const completeUrl = this.apiUrl(url);

    const headerDict = {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.post(completeUrl, obj, requestOptions)
  }

  // public apiLogout(url: any, header: any): Observable<any> {
  //   var headerDict
  //   headerDict = {
  //     'Authorization': `Bearer ${localStorage.getItem('userSecret')}`,
  //     'Access-Control-Allow-Origin': '*',
  //     'Content-Type': 'application/json',
  //     'Cache-Control': 'no-cache',
  //     'Pragma': 'no-cache'
  //   }

  //   if (header !== undefined || header !== null)
  //     headerDict = { ...headerDict, ...header }

  //   const requestOptions = {
  //     headers: new HttpHeaders(headerDict),
  //   };

  //   const completeUrl = this.apiSsoUrl(url);
  //   return this.http.get(completeUrl, requestOptions)
  // }

}
